<div class="icon-wrapper">
    <span class="ham-icon"> <i class="exclamation-outline-icon"></i> </span>
</div>
<div>
    <h1>{{ 'aumico_invitation_expired_title' | i18next }}</h1>
    <p>{{ 'aumico_invitation_expired_description' | i18next }}</p>
</div>
